import { compose } from 'redux';

import { lifecycle, pure, mapProps } from 'recompose';
import { identity, defaults } from 'lodash';

import { withRouter } from '../HOC/withRouter';

const logger = console;

const log = {
    error: {
        routeEnter(routeEnter) {
            logger.warn(`The onRouteEnter has to be a function. You have supplied: ${typeof routeEnter}`);
        },
        routeLeave(routeLeave) {
            logger.warn(`The onRouteLeave has to be a function. You have supplied: ${typeof routeLeave}`);
        },
        reRoute(reRoute) {
            logger.warn(`The shouldReRoute has to be a function. You have supplied: ${typeof reRoute}`);
        },
    },
};

const enterHandler = props => {
    if (typeof props.read === 'function') {
        props.read();
    }
};

const leaveHandler = props => {
    if (typeof props.clear === 'function') {
        props.clear();
    }
};

const reRouteHandler = (oldProps, newProps) =>
    oldProps.location.pathname !== newProps.location.pathname ||
    oldProps.location.search !== newProps.location.search ||
    oldProps.location.hash !== newProps.location.hash;

const routeDependencies = config => {
    const defaultConfig = {
        onRouteEnter: enterHandler,
        onRouteLeave: leaveHandler,
        shouldReRoute: reRouteHandler,
        propsMapping: identity,
    };
    const { onRouteEnter, onRouteLeave, shouldReRoute, propsMapping } = defaults(config, defaultConfig);
    return compose(
        withRouter,
        lifecycle({
            componentDidMount() {
                if (typeof onRouteEnter !== 'function') {
                    log.error.routeEnter(onRouteEnter);
                } else {
                    onRouteEnter(this.props);
                }
            },
            componentDidUpdate(prevProps) {
                if (typeof shouldReRoute !== 'function') {
                    log.error.reRoute(shouldReRoute);
                } else if (typeof onRouteEnter !== 'function') {
                    log.error.routeEnter(onRouteEnter);
                } else if (typeof onRouteLeave !== 'function') {
                    log.error.routeLeave(onRouteLeave);
                } else if (shouldReRoute(prevProps, this.props)) {
                    onRouteLeave(this.props);
                    onRouteEnter(this.props);
                }
            },
            componentWillUnmount() {
                if (typeof onRouteLeave !== 'function') {
                    log.error.routeLeave(onRouteLeave);
                } else {
                    onRouteLeave(this.props);
                }
            },
        }),
        pure,
        mapProps(propsMapping),
    );
};
export default routeDependencies;
